import Head from "@modules/common/components/head";
import Business from "@modules/home/business";
import DemoForm from "@modules/home/contact-form";
import Customization from "@modules/home/customization";
import Hero from "@modules/home/hero";
import OurClients from "@modules/home/our-clients";
import PosSystems from "@modules/home/pos-systems";
import Statement from "@modules/home/statement";
import { Homepage } from "types/homepage";
import { PosSystem } from "types/posSystem";
import { Restaurant } from "types/restaurant";

export default function Home({
  restaurants,
  systems,
  homepage,
}: {
  restaurants: Restaurant[];
  systems: PosSystem[];
  homepage: Homepage;
}) {
  return (
    <div className="flex flex-col gap-20  lg:gap-32 lg:pt-16">
      <Head />
      <Hero
        data={{
          heroSloganPart1: homepage.heroSloganPart1,
          heroSloganPart2: homepage.heroSloganPart2,
          heroBody: homepage.heroBody,
          heroImages: homepage.heroImages,
        }}
      />
      <Statement
        data={{
          statementProfitableText: homepage.statementProfitableText,
          statementDataDriventext: homepage.statementDataDriventext,
          statementPerfectMomentText: homepage.statementPerfectMomentText,
          statementWithoutManualWorkText:
            homepage.statementWithoutManualWorkText,
          statementSpotlighText: homepage.statementSpotlighText,
        }}
      />
      <Business
        data={{
          businessSectionTitle: homepage.businessSectionTitle,
          businessSectionText: homepage.businessSectionText,
          businessSectionToggles: homepage.businessSectionToggles,
        }}
      />
      <Customization
        data={{
          customerSectionTitle: homepage.customerSectionTitle,
          customerSectionText: homepage.customerSectionText,
          customerSectionChooseColorText:
            homepage.customerSectionChooseColorText,
          customerSectionChooseColorTitle:
            homepage.customerSectionChooseColorTitle,
          steps: homepage.steps,
        }}
      />
      <PosSystems systems={systems} />
      <OurClients restaurants={restaurants} />
      <DemoForm />
    </div>
  );
}

export async function getStaticProps() {
  const strapiUrl = process.env.NEXT_PUBLIC_STRAPI_URL;
  const headers = {
    Authorization: `Bearer ${process.env.NEXT_PUBLIC_STRAPI_TOKEN}`,
  };

  let restaurants = [];
  let homepage = {};
  let systems = [];

  try {
    // Fetch restaurants data
    const restaurantsResponse = await fetch(
      `${strapiUrl}/api/restaurants?populate=*&sort[0]=sortingIndex`,
      { headers }
    );

    // Fetch homepage data (single type)
    const homepageResponse = await fetch(
      `${strapiUrl}/api/homepage?populate=businessSectionToggles.icon&populate=businessSectionToggles.image&populate=heroImages&populate=steps.imageColor1&populate=steps.imageColor2&populate=steps.imageColor3`,
      { headers }
    );

    // Fetch systems data
    const systemsResponse = await fetch(`${strapiUrl}/api/systems?populate=*`, {
      headers,
    });

    if (restaurantsResponse.ok) {
      const restaurantsData = await restaurantsResponse.json();
      restaurants = restaurantsData.data || [];
    }

    if (homepageResponse.ok) {
      const homepageData = await homepageResponse.json();
      homepage = homepageData.data || {};
    }

    if (systemsResponse.ok) {
      const systemsData = await systemsResponse.json();
      systems = systemsData.data || [];
    }
  } catch (error) {
    console.error(`Error fetching data from Strapi: ${error}`);
  }

  // console.log("Restaurants", restaurants);
  // console.log("Homepage", homepage);
  // console.log("Systems", systems);

  return {
    props: {
      restaurants: restaurants,
      homepage: homepage,
      systems: systems,
    },
    revalidate: 10, // Revalidate every 10 seconds for fresh data
  };
}
